import { render, staticRenderFns } from "./newYearReportModal.vue?vue&type=template&id=198118d2&scoped=true&"
import script from "./newYearReportModal.vue?vue&type=script&lang=js&"
export * from "./newYearReportModal.vue?vue&type=script&lang=js&"
import style0 from "./newYearReportModal.vue?vue&type=style&index=0&id=198118d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198118d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('198118d2')) {
      api.createRecord('198118d2', component.options)
    } else {
      api.reload('198118d2', component.options)
    }
    module.hot.accept("./newYearReportModal.vue?vue&type=template&id=198118d2&scoped=true&", function () {
      api.rerender('198118d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/newYearReportModal.vue"
export default component.exports